export default '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m18.7249 4.67008-10 11.00002c-.18.2-.44.32-.72.33h-.02c-.27 0-.52-.1-.71-.29l-6-6.00002 1.41-1.41 5.26 5.26002 9.3-10.23002 1.48 1.35z" fill="currentColor"/></svg>';
export const title = "interface-checked";
export const tags = "nordicon interface checked symbol checkmark done ready";
